"use client";
import useErpUIController from "@/hooks/useGlobalContext";
import { api } from "@/lib/api";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useLocation } from "react-router";
import type { Config, Resident } from "../context/Provider";

function MainLayout({ children }: { children: React.ReactNode }) {
	const { controller, setPageTitle, setResident, setPageLoading, setConfig } = useErpUIController();

	const { pageTitle } = controller;

	const { pathname } = useLocation();

	useEffect(() => {
		const pathLength = pathname.split("/").length;

		const firstTitle = pathname.split("/")[pathLength - 1];
		const secondTitle =
			(pathLength > 1 && pathname.split("/")[pathLength - 2]) || "";

		/*
			Format title to remove ' - ' from the word and also make every first letter capital
		*/
		const formattedFirstTitle = firstTitle
			.split("-")
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(" ");

		/*
			Format title to remove ' - ' from the word and also make very first letter capital
		*/
		const formattedSecondTitle = secondTitle
			.split("-")
			.map((word) => ` ${word.charAt(0).toUpperCase() + word.slice(1)}`)
			.join(" ");

		setPageTitle(`${formattedFirstTitle} ${formattedSecondTitle}`);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pathname]);

	useEffect(() => {
		document.title = pageTitle + " | Resident Services Portal" || "Login";
	}, [pageTitle]);

	const getConfig = async () => {
		const response = await api.get("/configurations");
		return response.data;
	}

	const { data: config, isLoading: isConfigLoading } = useQuery({
		queryKey: ["config"],
		queryFn: getConfig,
		staleTime: 1000 * 60 * 60 * 24,
		gcTime: 1000 * 60 * 60 * 24,
		refetchOnWindowFocus: true,
		refetchOnMount: false,
		refetchOnReconnect: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
	});

	useEffect(() => {
		if (config) {
			setResident(config.data.resident as Resident);
			setConfig(config.data as Config);
			setPageLoading(isConfigLoading);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [config]);


	return (
		<div className="overflow-x-hidden">{children}</div>
	);
}

export default MainLayout;
